import { render } from "./edit-schedule-modal.vue?vue&type=template&id=979eb0c4&scoped=true"
import script from "./edit-schedule-modal.vue?vue&type=script&lang=js"
export * from "./edit-schedule-modal.vue?vue&type=script&lang=js"

import "./edit-schedule-modal.vue?vue&type=style&index=0&id=979eb0c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979eb0c4"]])

export default __exports__